// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fuM9","question":"styles_question__R6C1O","inputVisibleButton":"styles_inputVisibleButton__3RT6U","note":"styles_note__3fJKZ"};